import Connector from 'connect-store';
import React = require('react');
import RoadGeoJSONProcessor from '../classes/processors/RoadGeoJSONProcessor';
import FileUploaderStore from '../stores/FileUploaderStore';
import FileUploaderView from './FileUploaderView';

const RoadUploadView = ({ publishing, count, onPublish, onReset, percent }: { publishing: boolean, count: number, onPublish: IFunction, onReset: IFunction, percent: number }) => {
  return (
    <div>
      <span>共有{count}组道路数据/ {percent}%</span>
      <button disabled={publishing || count === 0} onClick={onPublish}>发布</button>
      <button disabled={publishing || count === 0} onClick={onReset}>重置</button>
      <Connector
        label="点击上传车道采集数据"
        store={new FileUploaderStore(new RoadGeoJSONProcessor(), true)}
        View={FileUploaderView}
      />
    </div>
  );
};

export default RoadUploadView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/RoadUploadView.tsx